<script>
export default {
  name: 'IconWallet',
  props: {
    size: {
      type: [Number, String],
      default: 24,
    },
    color: {
      type: String,
      default: '#030309',
    },
  },
}
</script>

<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.94 2.20983L9.52995 7.81983H7.11995C6.71995 7.81983 6.32995 7.84983 5.94995 7.92983L6.94995 5.52983L6.98995 5.43983L7.04995 5.27983C7.07995 5.20983 7.09995 5.14983 7.12995 5.09983C8.28995 2.40983 9.58995 1.56983 11.94 2.20983Z"
      :fill="color"
    />
    <path
      d="M18.7301 8.09002L18.7101 8.08002C18.1101 7.91002 17.5001 7.82002 16.8801 7.82002H10.6201L12.8701 2.59002L12.9001 2.52002C13.0401 2.57002 13.1901 2.64002 13.3401 2.69002L15.5501 3.62002C16.7801 4.13002 17.6401 4.66002 18.1701 5.30002C18.2601 5.42002 18.3401 5.53002 18.4201 5.66002C18.5101 5.80002 18.5801 5.94002 18.6201 6.09002C18.6601 6.18002 18.6901 6.26002 18.7101 6.35002C18.8601 6.86002 18.8701 7.44002 18.7301 8.09002Z"
      :fill="color"
    />
    <path
      d="M12.52 17.6601H12.77C13.07 17.6601 13.32 17.3901 13.32 17.0601C13.32 16.6401 13.2 16.5801 12.94 16.4801L12.52 16.3301V17.6601Z"
      :fill="color"
    />
    <path
      d="M18.29 9.51982C17.84 9.38982 17.37 9.31982 16.88 9.31982H7.11999C6.43999 9.31982 5.79999 9.44982 5.19999 9.70982C3.45999 10.4598 2.23999 12.1898 2.23999 14.1998V16.1498C2.23999 16.3898 2.25999 16.6198 2.28999 16.8598C2.50999 20.0398 4.20999 21.7398 7.38999 21.9498C7.61999 21.9798 7.84999 21.9998 8.09999 21.9998H15.9C19.6 21.9998 21.55 20.2398 21.74 16.7398C21.75 16.5498 21.76 16.3498 21.76 16.1498V14.1998C21.76 11.9898 20.29 10.1298 18.29 9.51982ZM13.28 15.4998C13.74 15.6598 14.36 15.9998 14.36 17.0598C14.36 17.9698 13.65 18.6998 12.77 18.6998H12.52V18.9198C12.52 19.2098 12.29 19.4398 12 19.4398C11.71 19.4398 11.48 19.2098 11.48 18.9198V18.6998H11.39C10.43 18.6998 9.63999 17.8898 9.63999 16.8898C9.63999 16.5998 9.86999 16.3698 10.16 16.3698C10.45 16.3698 10.68 16.5998 10.68 16.8898C10.68 17.3098 11 17.6598 11.39 17.6598H11.48V15.9698L10.72 15.6998C10.26 15.5398 9.63999 15.1998 9.63999 14.1398C9.63999 13.2298 10.35 12.4998 11.23 12.4998H11.48V12.2798C11.48 11.9898 11.71 11.7598 12 11.7598C12.29 11.7598 12.52 11.9898 12.52 12.2798V12.4998H12.61C13.57 12.4998 14.36 13.3098 14.36 14.3098C14.36 14.5998 14.13 14.8298 13.84 14.8298C13.55 14.8298 13.32 14.5998 13.32 14.3098C13.32 13.8898 13 13.5398 12.61 13.5398H12.52V15.2298L13.28 15.4998Z"
      :fill="color"
    />
    <path
      d="M10.6799 14.14C10.6799 14.56 10.7999 14.62 11.0599 14.72L11.4799 14.87V13.54H11.2299C10.9199 13.54 10.6799 13.81 10.6799 14.14Z"
      :fill="color"
    />
  </svg>
</template>
